<template>
  <div class="flex flex-col items-center">
    <div class="flex w-full flex-col items-center">
      <div class="w-2h-24 relative mb-2 h-24">
        <BaseShape shape="7-sided-cookie" class="text-primary-container h-full w-full" />
        <BaseIcon
          size="32"
          class="text-on-primary-container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          >{{ feedbackTopic.icon }}</BaseIcon
        >
      </div>
      <h2 class="text-display-large grow px-2 text-center transition-all">
        {{ feedbackTopic.title }}
      </h2>
      <div class="flex w-28 flex-row justify-end"></div>
    </div>
    <div class="mb-4 flex w-full flex-row flex-wrap justify-center gap-1">
      <BaseChip v-if="feedbackTopic.includeSelf" icon="account_circle" type="assist">{{
        $t('perspectives.self.default')
      }}</BaseChip>
      <BaseChip
        v-for="perspective in feedbackTopic.perspectives"
        :key="perspective.key"
        :icon="perspective.icon"
        type="assist"
        >{{ perspective.title }}</BaseChip
      >
      <BaseChip v-if="feedbackTopic.duration" icon="timer" type="assist">{{
        feedbackTopic.duration
      }}</BaseChip>
    </div>
    <div class="flex w-full flex-col">
      <BaseComplexCMSContent
        v-if="feedbackTopic.description"
        :content="feedbackTopic.description"
        class="[&_h3]:text-headline-medium [&_p]:text-body-large [&_p]:text-on-surface-variant text-center [&_h3]:mb-2"
      />
    </div>
    <div v-if="feedbackTopic.externalLink" class="mb-12 flex w-full flex-row justify-end gap-1">
      <a :href="feedbackTopic.externalLink" target="_blank" rel="noopener noreferrer">
        <BaseTextButton
          size="XS"
          icon="arrow_outward"
          class="text-on-surface-variant! mt-1 self-end"
          >{{ $t('common.read-more') }}</BaseTextButton
        >
      </a>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseChip from '@/core/components/base/chip/BaseChip.vue'
  import BaseComplexCMSContent from '@/core/components/base/complex-content/BaseComplexCMSContent.vue'
  import type { CompleteFeedbackTopic } from '@/core/composables/use-complete-feedback-topics'

  interface Props {
    feedbackTopic: CompleteFeedbackTopic
  }

  defineProps<Props>()
</script>
